import React from "react";
import "./Get_Started_Today.css";

function Get_Started_Today() {
  return (
    <>
      <section className="Get_Started_Today">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
              <div className="text-holder">
                <h2 className="heading">Get Started Today!</h2>
                <p>
                  With a passionate team blending creativity with data driven
                  insights, we ensure your brand shines in a crowded
                  marketplace.
                </p>
                <p>
                  From digital screen advertising to full-scale marketing
                  strategies, we transform your ideas into impactful campaigns
                  that drive real results.
                </p>
              </div>
            </div>

            <div className="col-xxl-4 col-xl-5 col-lg-5 col-md-6 col-sm-10 col-12">
              <div className="card-img-holder desktop-view">
                <div className="img-holder first">
                  <img
                    className="get-started-img"
                    src={
                      process.env.PUBLIC_URL +
                      "/Assets/Images/Home/Get_Started_Today/emplyee.png"
                    }
                  />
                </div>

                <div className="card-bg-holder second"></div>

                <div className="img-holder third">
                  <img
                    className="get-started-img"
                    src={
                      process.env.PUBLIC_URL +
                      "/Assets/Images/Home/Get_Started_Today/trede.png"
                    }
                  />
                </div>

                <div className="card-heading-text vr-text-holder fourth">
                  <h3>
                    Creative <span>Solutions</span>
                  </h3>
                </div>

                <div className="card-heading-text hr-text-holder fifth">
                  <h3>
                    Measurable <span>Results</span>
                  </h3>
                </div>
              </div>

              <div className="card-img-holder mobile-view">
                <div className="row me-0 ms-0">
                  <div className="col-6">
                    <div className="card-heading-text vr-text-holder ">
                      <h3>
                        Creative <span>Solutions</span>
                      </h3>
                    </div>
                    <div className="img-holder ">
                      <img
                        className="get-started-img"
                        src={
                          process.env.PUBLIC_URL +
                          "/Assets/Images/Home/Get_Started_Today/emplyee.png"
                        }
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="card-heading-text hr-text-holder ">
                      <h3>
                        Measurable <span>Results</span>
                      </h3>
                    </div>
                    <div className="img-holder ">
                      <img
                        className="get-started-img"
                        src={
                          process.env.PUBLIC_URL +
                          "/Assets/Images/Home/Get_Started_Today/trede.png"
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Get_Started_Today;
